<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "miten-tehda-treenaamisesta-hauskaa";
    let title = "Miten tehdä treenaamisesta hauskaa?";
    let author = "Markus";
    let blogDate = "12.12.2017";
    let titlePic = "dynamopaidat.jpg";
    let firstPara = "Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>

            <p>Kaikki tietää, että kehittyminen vaatii säännöllistä treenaamista. Säännöllisyys on siis kaiken keskiössä. Niinpä jos me emme viihdy jumpatessa, niin jaksammeko touhuta säännöllisesti? Pettämätön logiikka siis todistaa, että kehittymisen avain on hauskat treenit.</p>

            <p>Kaikki varmaan voivat yhtyä siihen, että salille lähteminen on joskus raskasta. Mitä enemmän laiskottaa sitä tarkemmin käymme läpi tulevaa koitosta: mitä jos en jaksakaan, mitä jos ei huvita tehdä tänään mitään?</p>

            <p>Nämä ovat yleisiä ja oikein hyviä ajatuksia. Meillä kaikilla on aina huonoja ja vielä huonompia päiviä. Silti aina treenin jälkeen olo on mitä parhain. Hyvä fiilis on paras palkkio siitä, että voitti jälleen itsensä.</p>

            <p>Hauskat ja yllätykselliset harjoitukset ovat dynamosalin “The Juttu”. Jatka lukemista niin pääset jyvälle mukaansatempaavan harjoittelun kulmakivistä.</p>

            <h2>Treenikaverit</h2>

            <p>Treenikaveri on parasta, mitä salille voi ottaa mukaan. Se on jopa tärkeämpi kuin kyykkykengät tai puhtaat trikoot. Onnistumisen riemu on parasta, kun sen voi jakaa kaverin kanssa. Kanssaurheilijat myös haastavat melko usein ylittämään itsensä.</p>

            <p>Treenikaveria ei tarvitse hakea aina omasta lähipiiristä, se voi löytyä myös salilta. Ole siis rohkea ja avaa suusi, kun muita treenaajia on paikalla. Yhdessä tekemällä kaikesta tulee hauskempaa. Kaverin kannustaessa raskaatkin asiat tuntuvat kevyemmiltä.</p>

            <img src='/svelte-site/img/blog/heidi-kivi_Fotor.jpg' alt="Iso kivi" width="670" height="539" />

            <h2>Vaihtelevuus</h2>

            <p>Saman harjoituksen tekeminen alkaa melko äkkiä tuntumaan helpolta ja ehkä kivaltakin. Sanotaan, että kehitys loppuu tyytyväisyyteen. Pelkällä puuhastelulla omalla mukavuusalueella ei saada tuloksia. Uuden oppiminen ja kehittyminen vaativat aina astumista epämukavuusalueelle.</p>

            <p>Meidän treenimme ovat aina vähän erilaisia. Teemme saman treenin lähinnä silloin, kun haluamme testata, että olemmeko kehittyneet. Pitkässä juoksussa me kaikki huomamme, että vaihtelevuus on paljon mukavampaa kuin saman toistaminen, vaikka se ei aina olisi se helpoin vaihtoehto.</p>

            <p>Ei ole mitään mieltä toistaa saamaa treeniä kerta toisensa jälkeen. Jostain syystä niin siinä vain monesti käy. Salille tullessa tehdään ne samat liikkeet samoilla painoilla yhä uudestaan ja uudestaan. Mitäpä jos tulisitkin salille ensi kerralla sillä mielin, että treenikaveri saa päättää mitä teet?</p>

            <h2>Yllätyksellisyys</h2>

            <p>Uudet Dynamosalilaiset usein arastelevat yhteistreenejä, koska eivät omien sanojensa mukaan osaa. Turha pelko, sillä ei meillä muutkaan tiedä, mitä tuleman pitää! Ja tietenkin salilla kannattaa ottaa treeniseurasta ja koutseista kaikki hyöty irti. Meille tullaan oppimaan ja kehittymään. Älä siis epäröi kysellä, testailla ja ihmetellä.</p>

            <p>Mennään yhdessä kohti tuntematonta. Porukalla pimeä metsäkin on vähemmän pelottava kuin yksin :).</p>

            <h2>Leikkimielisyys / hulluus / itsensä ylittäminen</h2>

            <p>Dynamosalilla ollaan aina välissä vähän kaheleita. Meillä on treenejä, joita kukaan ei jaksa tehdä. Osallistumme monesti leikkimielisiin urheilutapahtumiin, jotka ovat vähän hulluja. Silti näissä kaikissa on taustalla ihan ajatustakin.</p>

            <p>Myös me aikuiset saamme olla vähän lapsellisia ja tehdä pöhköjä asioita. Hulluissa treeneissä me venytämme omaa kuvitelmaamme siitä, mitä me tai meidän kroppa pystyy tekemään. Kun annamme itsellemme luvan uskoa, että pystymme tekemään enemmän, paremmin ja kovempaa, niin kehitymme entistä nopeammin.</p>

            <p>Uskalla olla siis rohkea ja välissä hullutella. Anna itsellesi mahdollisuus venyttää niitä rajoja, joita olet aiemmin omalle suorituskyvyllesi asettanut.</p>


            <p>-Markus</p>

            <img src='/svelte-site/img/blog/markus.jpg' alt="Markus">
        </article>



        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nuts-karhunkierros-2019-83km' title='Ensikertalaisena NUTS Karhunkierroksella' titlePic='karhunkierros.jpg' blogDate='' firstPara='Kaikki alkoi jostain tyhmästä ideasta, joka alkoi pikkuhiljaa paisua. Lähteä nyt juoksemaan Karhunkierros, oletko ikinä kokeillut vaeltaa sitä, no en ole. Ja nyt se oli edessä. 83 km, hirvitti.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='muscle_up_renkaissa' title='Muscle up renkaissa' titlePic='2018/muscleup_strip.jpg' blogDate='' firstPara='Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='selkavaivat_kuriin_treenaamalla' title='Selkävaivaisena treenaamisesta' 
                    titlePic='2014/levytanko.jpg' firstPara='Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.' blogDate=''></BlogSummary>
                </article>
            </div>
        </section>

        
    </div>
{/if}

<style>


</style>